export default "__VITE_ASSET__B92gI4hU__"